export const headerStyles = {
  xs: {
    container: {
      paddingX: "4px",
      height: "11px"
    },
    time: {
      fontSize: "0.3125rem !important"
    }
  },
  md: {
    container: {
      paddingX: "10px",
      height: "25px"
    },
    time: {
      fontSize: "0.625rem !important"
    }
  }
}